<ng-container>
  <app-header-public
    (openedEvent)="receiveOpenedSideNav($event)"
    [isLoggedIn]="isLoggedIn"
    [name]="name()"
    [burgerMenuActive]="burgerMenuActive"
  ></app-header-public>
  @if(isLoggedIn && !burgerMenuActive){
  <app-header-private-desktop></app-header-private-desktop>
  } @if(isLoggedIn && burgerMenuActive){
  <app-header-private-burger></app-header-private-burger>
  }

  <div
    class="router"
    [ngClass]="{
      'router-borrower': isLoggedIn && userType === 'prestatario',
      'router-affiliate': isLoggedIn && ( userType === 'afiliado' || userType ==='comercial' ),
      'router-out': !isLoggedIn || (isLoggedIn && userType == null),
      'no-sidenav-active': burgerMenuActive
    }"
  >
    <div
      class="router-outlet"
      [ngClass]="{
        'with-sidenav': isLoggedIn && !burgerMenuActive,
        'router-landing': !isLoggedIn
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
